/**
 * Detecta visualização embutida (preview de e-mail, iframe sandbox, webview
 * restrito) onde a SPA não roda de forma confiável.
 */
export function isEmailPreviewContext() {
  if (typeof window === 'undefined') return false;

  if (window.__E2E__) return false;
  if (/[?&]e2e=1\b/.test(window.location.search || '')) return false;

  // Rotas /embed/** são embutidas propositalmente em iframes (ex.: Sofia na
  // landing promo.consultamais.org). Bypass do gate — a proteção contra
  // preview de e-mail continua ativa em todas as outras rotas.
  try {
    if (/^\/embed(\/|$)/i.test(window.location.pathname || '')) return false;
  } catch {}

  try {
    if (window.top !== window.self) return true;
  } catch {
    return true;
  }

  return false;
}

export function getOpenInBrowserUrl() {
  if (typeof window === 'undefined') return 'https://consultamais.app/';
  return window.location.href;
}
